import React from 'react'
import { StyleSheet, ScrollView, TouchableOpacity } from 'react-native'
import { Modal, Icon, useTheme } from '@ui-kitten/components'

export const ModalView = React.memo(function ModalView({ isVisible, setIsVisible, children }) {
  const theme = useTheme()

  return (
    <Modal style={[styles.modal, { backgroundColor: theme['background-basic-color-1'] }]}
      visible={isVisible}
      backdropStyle={styles.backdrop}
      onBackdropPress={() => setIsVisible(false)}
    >
      <ScrollView style={{flex: 1}} contentContainerStyle={styles.modalContainer}>
        <TouchableOpacity
          style={{position: 'absolute', top: 10, right: 10, alignSelf: 'flex-end', alignItems: 'center', justifyContent: 'center'}}
          onPress={() => {
            setIsVisible(false)
          }}
        >
          <Icon name='close-circle' width={32} height={32} fill={theme['text-basic-color']} />
        </TouchableOpacity>
        { children }
      </ScrollView>
    </Modal>
  )
}, function(prev, next) {
  if (prev.isVisible !== next.isVisible) {
    return false
  }
  return false
})

const styles = StyleSheet.create({
  modal: {
    top: 100,
    width: '80%',
    height: '80%',
    borderRadius: 20,
  },
  modalContainer: {
    alignItems: 'stretch',
    padding: 32,
  },
  backdrop: {
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },
})
